import { useState } from 'react';

import { useFiles } from '@/entities/file';
import { useModalsStore } from '@/widgets/modals/modals.store';

const FINAL_PDF_NAME = 'LAST WILL AND TESTAMENT.pdf';

export const useDisplayFileStoragePdf = () => {
  const { decryptDocumentFile } = useFiles();
  const modals = useModalsStore();
  const [loading, setLoading] = useState(false);

  return {
    displayPdf: async (filepath: string, fileName: string = FINAL_PDF_NAME) => {
      setLoading(true);
      const file = await decryptDocumentFile(filepath);

      if (!file) {
        setLoading(false);
        return;
      }

      modals.openModal({
        type: 'FilePreviewModal',
        mode: 'fileInfo',
        fileInfo: {
          url: URL.createObjectURL(file),
          fileType: 'pdf',
          name: fileName,
        },
      });
      setLoading(false);
    },
    displayDecryptedFile: (file: File, fileName: string = FINAL_PDF_NAME) => {
      modals.openModal({
        type: 'FilePreviewModal',
        mode: 'fileInfo',
        fileInfo: {
          url: URL.createObjectURL(file),
          fileType: 'pdf',
          name: fileName,
        },
      });
    },
    loading,
  };
};
